import Functions from './functions';
import Lang from './lang';
import TableMultipleDeletable from './table/multiple_deletable';
import TableBase from './table/base';
import TableFilterable from './table/filterable';
import TableFilterableSingleDeletable from './table/filterable_single_deletable';
import TableFilterableMultipleDeletable from './table/filterable_multiple_deletable';
import TableUpdatable from './table/updatable';
import TableUpdatableSingleDeletable from './table/updatable_single_deletable';

var FASTWAX = window.FASTWAX || {};

FASTWAX.Functions = Functions;

FASTWAX.TableMultipleDeletable = TableMultipleDeletable;

FASTWAX.TableBase = TableBase;

FASTWAX.TableFilterable = TableFilterable;

FASTWAX.TableFilterableSingleDeletable = TableFilterableSingleDeletable;

FASTWAX.TableFilterableMultipleDeletable = TableFilterableMultipleDeletable;

FASTWAX.TableUpdatable = TableUpdatable;

FASTWAX.TableUpdatableSingleDeletable = TableUpdatableSingleDeletable;

FASTWAX.lang = new Lang();

export default FASTWAX;


/** WEBPACK FOOTER **
 ** ./src/common/fastwax.js
 **/